import {IPaylodAction, ISingleViewDispatcher} from '../../interfaces/dispatchers'
import DataActions from '../../enums/ActionTypes/DataActions'
import {IStore} from '../../interfaces/reducers'
import {Feature, FeatureStatus} from '../../models'
import {ServiceHub} from '../../ServiceHub'

export class SingleViewDispatcher implements ISingleViewDispatcher {
  constructor() {
    this.setSelectedFeature = this.setSelectedFeature.bind(this)
    this.removeSelection = this.removeSelection.bind(this)
  }
  public removeSelection() {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      dispatch({
        type: DataActions.REMOVE__SINGLE_VIEW_SELECTED_FEATURE,
        payload: undefined
      })
    }
  }
  public setSelectedFeature(feature: Feature, id: string) {
    return (dispatch: (data: IPaylodAction) => void, getStore: () => IStore) => {
      const layerInfo = getStore().layerInfos.featureLayerInfos[id]
      if (layerInfo && layerInfo.sourceDescription.hasAttachments && feature.status != FeatureStatus.New) {
        dispatch({
          type: DataActions.SET_SINGLE_VIEW_SELECTED_FEATURE,
          payload: {
            feature,
            id,
            loading: true
          }
        })
        ServiceHub.gisCrudService.attachAttachments({layerInfo: layerInfo, features: [feature]}).then(features => {
          dispatch({
            type: DataActions.SET_SINGLE_VIEW_SELECTED_FEATURE,
            payload: {
              feature: features[0],
              id,
              loading: false
            }
          })
        })
      } else {
        dispatch({
          type: DataActions.SET_SINGLE_VIEW_SELECTED_FEATURE,
          payload: {
            feature,
            id,
            loading: false
          }
        })
      }
    }
  }
}
